export default __webpack_public_path__ + "static/media/Will of Atali.52b6d591.jpg";